import { Div, A } from '@codesuma/baseline'
import { SheetPage } from '../../components/sheet-page'
import { CONTACT_EMAIL } from '../../configs/app'
import style from './index.module.css'

// Contact page: one address, the same one the privacy page points at. A real
// mailto anchor rather than a tap handler, so the OS offers it the way it
// offers any other link — long-press to copy, open in the mail app.
export const ContactPage = () => {
    const base = SheetPage('تماس با ما')

    const intro = Div('برای پرسش، پیشنهاد، یا گزارش اشکال با ما در تماس باشید. همه‌ی پیام‌ها خوانده می‌شوند.')
    intro.addClass(style.intro)
    base.append(intro)

    const email = A(`mailto:${CONTACT_EMAIL}`, CONTACT_EMAIL)
    email.addClass(style.email)
    base.append(email)

    return base
}
